<template>
  <div class="project-experience">
    <h4>{{ title }}</h4>
    <div class="charts-container">
      <ScientificScopesItem
        v-for="udcItem in topUdcStats"
        :key="udcItem.udcClassId"
        :item="udcItem"
      />
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import ScientificScopesItem from '@/components/profile/projects/scientific-scopes/ScientificScopesItem.vue';

  defineProps({
    title: {
      type: String,
      default: 'УДК проектов',
    },
  });

  const api = useApi();
  const topUdcStats = ref([]);

  onMounted(async () => {
    await getTopUdcStats();
  });

  const getTopUdcStats = async () => {
    try {
      const response = await api.projectExecutor.topUdcStats();
      topUdcStats.value = response.udc.items;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style scoped>
  .project-experience {
    padding: 20px;
    background-color: #f2f4f8;
    border-radius: 4px;
    width: 100%;
  }

  h4 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
  }

  .charts-container {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    justify-content: center;
  }

  .legend li {
    display: flex;
    align-items: center;
    font-size: 12px;
    margin: 5px 0;
  }

  .legend span {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>
